var map = {
	"./dentist-01.jpg": 5204,
	"./dentist-02.jpg": 69813,
	"./dentist-03.jpg": 60645,
	"./dentist-04.jpg": 71781,
	"./fertility-01.jpg": 11783,
	"./fertility-02.jpg": 75676,
	"./fertility-03.jpg": 78726,
	"./fertility-04.jpg": 93784,
	"./fertility-05.jpg": 39983,
	"./footer-img-01.jpg": 4078,
	"./footer-img-02.jpg": 724,
	"./footer-img-03.jpg": 54234,
	"./footer-img-04.jpg": 68643,
	"./service-1.jpg": 44105,
	"./service-2.jpg": 38856,
	"./service-3.jpg": 41177,
	"./service-doctor-01.jpg": 50445,
	"./service-doctor-02.jpg": 28967,
	"./service-doctor-03.jpg": 17143,
	"./service-doctor-04.jpg": 77246,
	"./service-doctor-05.jpg": 47807,
	"./service-doctor-06.jpg": 4985,
	"./service-doctor-07.jpg": 44627,
	"./service-doctor-08.jpg": 29512,
	"./service-doctor-09.jpg": 19316,
	"./service-doctor-10.jpg": 93819,
	"./service-img-01.jpg": 7653,
	"./service-img-02.jpg": 10162,
	"./service-img.jpg": 57310,
	"./treatment-01.jpg": 13417,
	"./treatment-02.jpg": 90677,
	"./treatment-03.jpg": 21181,
	"./treatment-04.jpg": 18365,
	"./treatment-05.jpg": 47076,
	"./treatment-1.jpg": 78438,
	"./treatment-2.jpg": 56503,
	"./treatment-3.jpg": 72641,
	"./treatment-4.jpg": 24115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38836;